import { Component, OnInit, Input } from '@angular/core';

import { ViewCell } from '@app/shared/smart-table/ng2-smart-table';
import { StationService } from '@app/core/station.service';

@Component({
  standalone: false,
  selector: 'app-station-name',
  template: `
    {{ renderValue }}
  `
})
export class StationNameComponent implements OnInit, ViewCell {
  @Input() value: string;
  @Input() rowData: any;

  public renderValue: string;
  stationTypes = this.stationService.stationTypes;

  constructor(private stationService: StationService) {}

  ngOnInit() {
    if (this.stationTypes) {
      const index = this.stationTypes.findIndex(s => s.value === this.value);
      if (index !== -1) {
        this.renderValue = this.stationTypes[index].name;
      }
    }
  }
}
